import { Box, Container, CssBaseline, Stack } from '@mui/material'
import {
  NAVIGATION_BAR_WIDTH,
  NavigationBar,
} from 'components/NavigationBar/NavigationBar'
import { APP_BAR_HEIGHT, AppBar } from 'components/AppBar/AppBar'
import { Footer, footerMaxHeight } from 'components/Footer/Footer'

export const Page = (props: {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
}) => {
  return (
    <>
      <CssBaseline />
      <Container maxWidth={false} disableGutters>
        <AppBar />
      </Container>
      <Stack direction="row">
        <NavigationBar />
        <Box
          id="page-scroll-container"
          sx={{
            height: `calc(100vh - 65px)`,
            flex: 1,
            position: 'relative',
            top: `${APP_BAR_HEIGHT}px`,
            ml: { xs: 0, sm: `${NAVIGATION_BAR_WIDTH}px` },
            pb: { xs: '21px', sm: '14px' },
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          {props.header}
          <Box
            px={{ xs: '16px', sm: '48px' }}
            pt={{ xs: '21px', sm: 4 }}
            pb={{
              xs: `${props.footer ? footerMaxHeight : 0 + 21}px`,
              sm: `${props.footer ? footerMaxHeight : 0 + 32}px`,
            }}
          >
            {props.children}
          </Box>
        </Box>
        {props.footer && (
          <Footer navigationBarWidth={NAVIGATION_BAR_WIDTH}>
            {props.footer}
          </Footer>
        )}
      </Stack>
    </>
  )
}
